import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { EmailTemplate } from "@rumble-it/common-lib/types/models/EmailTemplate.interface";
import { EyeOutlined } from "@ant-design/icons";

export const emailTemplateColumns: TableColumnsType<EmailTemplate> = [
  {
    title: "Titel",
    dataIndex: "title",
    key: "title",
    render: (_: any, record: EmailTemplate) => (
      <Link to={`/email-templates/${record.id}`}>{record.title}</Link>
    ),
  },
  {
    title: "Onderwerp",
    dataIndex: "subject",
    key: "subject",
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/email-templates/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
